import { render, staticRenderFns } from "./SessionSlider.vue?vue&type=template&id=295f2e90&"
import script from "./SessionSlider.vue?vue&type=script&lang=js&"
export * from "./SessionSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports